import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';

import { LOADER_INTERCEPTOR_DISABLED_TOKEN } from '@shared/components/loader/loader.interceptor';
import {
  PreferenciaUsuarioModel,
  PreferenciaUsuarioModelos,
  PreferenciaUsuarioTipos,
} from './preferencia-usuario.model';

@Injectable({ providedIn: 'root' })
export class PreferenciaUsuarioService {
  private readonly apiPath = '/frontend-api/v1/preferencia-usuario';

  private httpClient = inject(HttpClient);

  get<T extends PreferenciaUsuarioModelos>(tipo: PreferenciaUsuarioTipos) {
    const path = `${this.apiPath}/${tipo}`;
    return this.httpClient
      .get<PreferenciaUsuarioModel>(path)
      .pipe(map((pref) => pref?.preferencias as T));
  }

  set<T extends PreferenciaUsuarioModelos>(
    tipo: PreferenciaUsuarioTipos,
    preferencias: T | null
  ) {
    const path = `${this.apiPath}/${tipo}`;
    return this.httpClient.patch<void>(path, preferencias, {
      context: new HttpContext().set(LOADER_INTERCEPTOR_DISABLED_TOKEN, true),
    });
  }
}
